import ManageAutoPay from "./manage-autopay";

export default ManageAutoPay;
